import React from "react";
import { Reply } from "@/types/fitconnect.ts";
import { LoadingCard } from "@/components/LoadingCard.tsx";
import { FileX } from "lucide-react";
import { reformatDate } from "@/lib/dateTime.tsx";

function prettifyJsonIfPossible(maybeJson: string): string {
  try {
    return JSON.stringify(JSON.parse(maybeJson), null, 2);
  } catch (e) {
    return maybeJson;
  }
}

export function ReplyList({
  isLoading,
  eventLogEntries,
}: {
  isLoading: boolean;
  eventLogEntries: Reply[];
}) {
  return (
    <section className="card shadow-sm bg-white h-fit">
      {isLoading && <LoadingCard />}
      <div className="card-body items-center justify-center">
        {eventLogEntries.length == 0 && (
          <div className="flex flex-col items-center justify-center text-gray-500">
            <FileX className="h-8 w-8 mb-2" />
            <p className="text-sm">Keine Daten</p>
          </div>
        )}
        {eventLogEntries.map((entry, index) => (
          <div
            key={entry.replyId}
            className="collapse collapse-arrow bg-base-100 border border-base-300"
          >
            <input
              type="radio"
              name="my-accordion-2"
              defaultChecked={index === 0}
            />
            <div className="collapse-title">
              <div className="badge badge-neutral mb-4">{entry.replyId}</div>
              <div className="text-slate-600 text-sm">
                {reformatDate(entry.receivedAt)}
              </div>
            </div>
            <div className="collapse-content text-sm">
              <div>Fachdatensatz:</div>
              <div>
                <span className="font-bold">{entry.dataMimeType}</span>-Daten
                nach Schema{" "}
                <a className="link" href={entry.dataSchemaUri} target="_blank">
                  {entry.dataSchemaUri}
                </a>
              </div>
              <pre className="whitespace-pre-wrap wrap-break-word rounded-md bg-base-300 p-4 text-sm leading-6 overflow-auto max-h-112">
                {prettifyJsonIfPossible(entry.data)}
              </pre>
              <div className="mt-4">Metadatensatz:</div>
              <pre className="whitespace-pre-wrap wrap-break-word rounded-md bg-base-300 p-4 text-sm leading-6 overflow-auto max-h-200">
                {prettifyJsonIfPossible(entry.metadata)}
              </pre>
              <div className="text-slate-600 text-sm mt-4">
                {entry.numAttachments} Anlagen
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
